import createHistory from 'history/createBrowserHistory'
export default createHistory()
// {
// 	basename: 'console'
// 	getUserConfirmation(message, callback) {
// 		// Show some custom dialog to the user and call
// 		// callback(true) to continue the transiton, or
// 		// callback(false) to abort it.
// 		console.log(message)
// 	}



// WEBPACK FOOTER //
// ./src/history/index.js